import { create } from 'zustand'

export interface OrganizationFromState {
  id: string
  name: string
  federalTaxId: string
}

interface ContractState {
  organization: OrganizationFromState | null
  setOrganization: (data: OrganizationFromState) => void
  clearOrganization: () => void
}

const useOrganizationStore = create<ContractState>((set) => ({
  organization: null,
  setOrganization: (data) => set({ organization: data }),
  clearOrganization: () => set({ organization: null }),
}))

export default useOrganizationStore
